import { render } from "./ReportsMain.vue?vue&type=template&id=86bdc0e8&scoped=true&lang=true"
import script from "./ReportsMain.vue?vue&type=script&lang=js"
export * from "./ReportsMain.vue?vue&type=script&lang=js"

import "./ReportsMain.vue?vue&type=style&index=0&id=86bdc0e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-86bdc0e8"

export default script